
import { formatMoney, isBigCard, isHighlighted, isHighlightedGold, isHighlightedSilver, isSuperHighlighted, showBathrooms, showBedrooms, showGuests, showM2, showRooms } from "@Utils/Functions"
import { CardImageGallery } from "../../Components/Property/PropertyCard/CardImageGallery/web"
import { useEffect, useRef, useState } from "react"
import { OwnerLogo } from "shared-components/Components/Property/OwnerLogo/web"
import { useContext } from "react"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context"
import "./ListingCard.less"

import dynamic from "next/dynamic"
import { Favorite } from "shared-components/Components/Property/Favorite/web"
import { TagEvent } from "shared-components/Components/TagEvent/web"
import { FiltersStateContext } from "shared-components/Contexts/Filters/context";
import { HouseIcon } from "shared-components/Components/CustomIcons/HouseIcon"
import { BathroomIcon } from "shared-components/Components/CustomIcons/BathroomIcon"
import M2Icon from "shared-components/Components/CustomIcons/M2Icon"
import PeopleIcon from "shared-components/Components/CustomIcons/PeopleIcon/web"
import { HighlightedIconBlack } from "shared-components/Components/CustomIcons/HighlightedIconBlack"
import { LeadButtons } from "shared-components/Components/Property/InformationRequestV2/LeadButtons/web"
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import { property_type_id } from "../SearchResults/Sider/TopBarFilters/options"
import { VirtualTourIcon } from "shared-components/Components/CustomIcons/VirtualTourIcon/web"
import { ProjectIcon } from "shared-components/Components/CustomIcons/ProjectIcon/web"
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web"
import { HighlightedIconSilver } from "shared-components/Components/CustomIcons/HighlightedIconSilver"
import { HighlightedIconGold } from "shared-components/Components/CustomIcons/HighlightedIconGold"
import { ProductTagIcon } from "shared-components/Components/CustomIcons/ProductTagIcon"
import { useTheme } from "shared-components/Styles/ThemeHook"
//@ts-ignore
const FacilitiesCard = dynamic(
	() =>
		import("shared-components/Components/Property/FacilitiesCard/web").then(
			mod => mod.FacilitiesCard
		),
	{ ssr: false }
);

type Event = {
	tag: string;
	show: boolean;
	link: string;
	logo: string;
	fecha_inicio_evento: string;
};

type ListingCardProps = {
	preloadImg?: boolean;
	showDuplicated?: boolean;
	data: {
		id?: any;
		legacy_propID?: any;
		isProject?: any;
		img?: any;
		owner?: {
			logo?: any;
			name?: any;
			inmoLink?: any;
			inmoPropsLink?: any;
			inmofull?: any;
			individual?: number
		};
		price?: any;
		currency?: any;
		currency_id?: any;
		hidePrice?: any;
		highlight?: any;
		property_type_id?: any;
		operation_type_id?: any;
		bedrooms?: any;
		bathrooms?: any;
		rooms?: any;
		m2?: any;
		guests?: any;
		title?: any;
		description?: any;
		neighborhood?: any;
		estate?: any;
		facilities?: any;
		link?: any;
		isExternal?: any;
		event?: Event;
		duplicated?: Listing[],
		commonExpenses?: any;
		commonExpenses_currency? : string;
	};
};

export const ListingCard = ({ data, preloadImg = false, showDuplicated=false, }: ListingCardProps) => {
	const [hover, setHover] = useState(false);
	const { order } = useContext(FiltersStateContext);
	const { country_code } = useContext(ConfigStateContext);
    const { theme } = useTheme();
	const isBig = isBigCard(data.highlight, order.value, country_code)
	const isSuperHigh = isSuperHighlighted(data?.highlight, country_code)
	const isHigh = isHighlighted(data?.highlight, country_code)
	const propertyType = property_type_id.filter((type) => type.value === data.property_type_id)[0]
	const [idealFilters, setIdealFilters] = useState<any>(false);
    const [alreadyShown,  setAlreadyShown] = useState(false);

    const divRef = useRef(null);

	const [duplicatedDropdown, setDuplicatedDropdown] = useState(false);
	const screen = useBreakpoint();

	const parentRef = useRef(null);

	const tags = genTagsText(data, theme.colors.primaryColor, country_code);
	const onHover = (e?: any) => {
		setHover(true);
	};
	const onHoverEnd = (e?: any) => {
		setHover(false);
	};

	const ids = ["190663135"];

	const toggleDuplicatedDropdown = () => {
		setDuplicatedDropdown(!duplicatedDropdown);
        setAlreadyShown(true);
		setTimeout(()=>{
			if(duplicatedDropdown) {
				const headerOffset = screen.xs ? 65 : 125; // Altura del header flotante
				const elementPosition = parentRef.current.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.scrollY - headerOffset;

				window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
				});
			}
		}, 30)
	};

	useEffect(() => {

		if (!data.isProject && data && "operation_type_id" in data && "property_type_id" in data) {
			setIdealFilters({
				operation_type_id: data.operation_type_id,
				property_type_id: [data.property_type_id],
				maxPrice: data.price + data.price * 0.2,
				bedrooms: [data.bedrooms],
				currencyID: Number(data.currency_id),
			});
		}

        if(!screen.lg) {
            const observer = new IntersectionObserver(
                ([entry]) => {
                  // Update state when the div enters or leaves the viewport
                  setHover(entry.isIntersecting);
                },
                {
                  root: null, // Use the viewport as the container
                  rootMargin: '0px',
                  threshold: 0.1, // Trigger when at least 10% of the div is visible
                }
            );

            if (divRef?.current) {
            observer.observe(divRef?.current);
            }

            return () => {
            if (divRef?.current) {
                observer.unobserve(divRef?.current);
            }
            };
        }
	}, []);

	if (!data || !data.id) return null;

	return (
			<div ref={divRef}>
				<div
					onMouseEnter={onHover}
					ref={parentRef}
                    onScrollCapture={onHover}
					onMouseLeave={onHoverEnd}
					className={`listingCard ${isBig ? "isBigCard" : ""} ${isSuperHigh ? 'isSuperHighlited' : ''} ${country_code} ${
						ids.includes(data.id.toString()) ? "special" : ""
					}`}
				>
					<CardLink data={data} className="lc-cardCover" target={screen?.lg ? '_blank':'_self'}>
						<div className="lc-galleryWrap">
							<CardImageGallery
								id={data.legacy_propID}
								idProject={data.id}
								mode={data.isProject ? "project" : "property"}
								image={data.img}
								hover={hover}
								preloaded={preloadImg}
								width={500}
								height={isSuperHigh ? 386 : 260}
							/>
						</div>
						<div className="lc-cardCoverTop">
							<div className="lc-cardCoverTop--tag-container">
								{tags?.map((t, i) => (
									<span className={`lc-tags tag-${t.name} ${t.icon && !t.text ? "lc-tags--icon" : ""}`} key={i}>
										{t.icon ? t.icon : null}
										{t.text ? <span>{t.text}</span> : null}
									</span>
								))}
								{ids.includes(data.id.toString()) && (
									<>
										<span className="lc-tags" key={8}>
											🌟 oportunidad
										</span>
										<span className="lc-tags" key={8}>
											🚀 tendencia
										</span>
									</>
								)}
							</div>

							{!data.isProject ? <Favorite id={data.legacy_propID} type="justIcon" /> : null}
						</div>

						{data.isProject &&
						data.event.show &&
						data.event.logo !== "" &&
						data.event.tag !== "" &&
						data.event.link !== "" ? (
							<TagEvent event={data.event} />
						) : null}
					</CardLink>

					<div className="lc-dataWrapper">
						{isSuperHigh && <div className="lc-owner-name">{data.owner.name}</div>}
						{data.owner?.individual === 0 && data?.owner?.logo && country_code !== "ce3" ? (
							<OwnerLogo
								logo={data.owner.logo}
								name={data.owner.name}
								inmoLink={data.owner.inmoLink}
								inmoPropsLink={data.owner.inmoPropsLink}
								inmoFull={data.owner.inmofull}
							/>
						) : null}
						<CardLink data={data} className="lc-data" target={screen?.lg ? '_blank':'_self'}>
							<div>
								<div className="lc-price" style={isSuperHigh ? { marginTop: 30 } : {}}>
									{data.currency && data.price && data.price >= 5 && !data.hidePrice ? (
										<>
											<strong>
												{data.isProject ? "Desde" : ""} {data.currency}{" "}
												{formatMoney(data.price)}
											</strong>
											{country_code === "ce3" && (
												<span className="qty-price">/noche</span>
											)}
										</>
									) : (
										<strong>Consultar</strong>
									)}

                                    {(data.operation_type_id !== 4 && data.commonExpenses && data.commonExpenses !== '') ?
										<span className="commonExpenses">
												+ {data.commonExpenses_currency + ' ' +formatMoney(data.commonExpenses)} GC
										</span>
                                    : null}
								</div>

								<strong className="lc-location">
									{propertyType ? `${propertyType.text} en ` : ""}{data.neighborhood}, {data.estate}
								</strong>
							</div>
							<div className="lc-typologyContainer">
								{data.isProject && <p className="lc-location">Unidades desde:</p>}
								<div className="lc-typologyTag">
									{showBedrooms([data.property_type_id], data.operation_type_id) && (
										<div className="lc-typologyTag__item">
											<span><BedIcon width={20}/></span>
											<span>{data.bedrooms == 0 ? "Mono" : data.bedrooms + " Dorm."}</span>
										</div>
									)}
									{showRooms([data.property_type_id], data.operation_type_id) && (
										<div className="lc-typologyTag__item">
											<span><HouseIcon width={18}/></span>
											<span>{data.rooms == 1
												? data.rooms + " Ambiente"
												: data.rooms + " Ambientes"}</span>
										</div>
									)}
									{showBathrooms([data.property_type_id], data.operation_type_id) && (
										<div className="lc-typologyTag__item">
											<span><BathroomIcon width={18}/></span>
											<span>{data.bathrooms} {data.bathrooms > 1 ? "Baños" : "Baño"}</span>
										</div>
									)}
									{showM2(data.operation_type_id) && data.m2 > 0 && (
										<div className="lc-typologyTag__item">
											<span><M2Icon color='currentColor'/></span>
											<span>{formatMoney(data.m2)} m²</span>
										</div>
									)}
									{showGuests(data.operation_type_id) && (
										<div className="lc-typologyTag__item">
											<span><PeopleIcon/></span>
											<span>{data.guests} Huéspedes</span>
										</div>
									)}
								</div>
							</div>

							<div>
								<h2>
									<span>{data.title}</span>
								</h2>
								<div style={{ display: "flex", gap: 80 }}>
									{isBig && <p className="lc-description">{data.description}</p>}
								</div>
							</div>

							<div style={{marginTop: 10}}>
								<LeadButtons
									listing={data}
									mode={data.isProject ? "project" : "property"}
									isInListing
									idealFilters={idealFilters}
									isProject={data.isProject}
								/>
							</div>

							{country_code === "ce3" && (
								<div style={{ marginTop: "-10px", maxWidth: "268px" }}>
									<FacilitiesCard
										facilities={data.facilities ?? []}
										dataFormat="idsArray"
									/>
								</div>
							)}
						</CardLink>
					</div>
				</div>

				{showDuplicated && data?.duplicated?.length > 0 && <>
					<div className='duplicated-banner' onClick={toggleDuplicatedDropdown}>
						<span>
							Hay {data.duplicated.length} publicaciones más de esta propiedad. &nbsp;
							<span style={{fontWeight:'bold'}}>{duplicatedDropdown ? 'Ver menos' : 'Ver todas'} </span>
						</span>
						{!duplicatedDropdown && <>
							<div className="arrow"><DownArrow/></div>
						</>}
						{duplicatedDropdown && <>
							<div className="arrow up"><DownArrow/></div>
						</>}
					</div>

                    <div className={`hidden-holder ${duplicatedDropdown ? 'show' : 'hide'}`} style={duplicatedDropdown ? {maxHeight: data.duplicated.length * (screen.lg ? 350 : 650), opacity: 1}:{}}>
                        {(alreadyShown || duplicatedDropdown) && <div className="duplicated-holder" style={{display:'flex', flexDirection:'column', gap: 16, marginTop: 16}}>
                            {data.duplicated.map((prop, index) => (
                                <div key={prop.id}>
                                    <ListingCard data={prop} preloadImg={preloadImg} showDuplicated={false}/>
                                    {index===data.duplicated.length-1 && <div className='duplicated-banner' onClick={toggleDuplicatedDropdown}>
                                        <span>
                                            Viste todas las publicaciones de esta propiedad. &nbsp;
                                            <span style={{fontWeight:'bold'}}>{duplicatedDropdown ? 'Ver menos' : 'Ver todas'} </span>
                                        </span>
                                        <div className="arrow up"><DownArrow/></div>
                                    </div>}
                                </div>
                            ))}
                        </div>}
                    </div>


				</>}

			</div>
	);
};

const genTagsText = (data, primaryColor, country_code) => {
	let tags = [];

	if (country_code == "ce3" && data.seaDistanceName !== null)
		tags.push({
			name: "seaDistance",
			text: `${data.seaDistanceName} ${
				data.seaDistanceName != "frente al mar" ? "del mar" : ""
			}`,
			icon: null
		});

	if (data.highlight) {
		if (isSuperHighlighted(data.highlight)) {
			tags.push({ name: "isSuperHighlighted", text: "Destacado", icon: <HighlightedIconBlack width={20} height={20} /> });
		} else if (isHighlighted(data.highlight) || isHighlightedGold(data.highlight)) {
			tags.push({ name: "isHighlightedGold", text: "Destacado", icon: <HighlightedIconGold width={20} height={20} /> });
		} else if (isHighlightedSilver(data.highlight)) {
			tags.push({ name: "isHighlightedSilver", text: "Destacado", icon: <HighlightedIconSilver width={20} height={20} /> });
		}
	}

    if (data.tags && !!data.tags.length) {
        data.tags.map((tag) => {
            tags.push({ name: `tag-${tag.tag_type}`, text: tag.tag_type, icon: <ProductTagIcon width={16} color={primaryColor} /> });
        })
    }

	if (data.isProject) tags.push({ name: "isProject", text: null, icon: <ProjectIcon width={18} height={18} /> });
	if (data.isExternal) tags.push({ name: "isExternal", text: "Ficha externa", icon: null });
	if (data.tour3d) tags.push({ name: "tour3d", text: null, icon: <VirtualTourIcon width={25} height={25} /> });

	return tags;
};

const CardLink = ({ children, data, className = "" ,target = '_blank'}) => {
	let link = data.link;
	let isExternal = data.isExternal;

	//@hardcoded - pedido especial de hardcodeo, en algun momento habria que sacar esto y usar directamente data.link y data.isExternal en el render del componente
	if (data.isProject && (data.id == 13755 || data.legacy_propID == 189503363)) {
		link = "https://www.campiglia.com.uy/propiedades_destacadas";
		isExternal = true;
	}
	if (data.id == 15017476) {
		link = "https://landings.infocasas.com.uy/cumbres-jose-ignacio";
		isExternal = true;
	}
	//END @hardcoded - pedido especial de hardcodeo
	const clickHandler = (e: any) => {
		const isOverlayClick =
			e.target.classList.contains("overlay-cta") || e.target.closest(".overlay-cta");

		if (isOverlayClick) {
			e.preventDefault();
		} else if (data.isExternal) {
			e.preventDefault();

			window.open(
				data.link,
				"_blank",
				"location=yes,height=670,width=620,scrollbars=yes,status=yes"
			);
		}
	};

	return (
		<a
			className={className}
			target={target}
			title={data.title}
			href={!data.isExternal ? link : "#"}
			rel={isExternal ? "nofollow" : null}
			onClick={clickHandler}>
			{children}
		</a>
	);
};
